import React from 'react';

const RoomShowcaseSection = () => {
  const rooms = [
    {
      title: "Deluxe",
      subtitle: "Experience unmatched comfort",
      description: "Experience unmatched comfort in the Deluxe Rooms at Hotel Prakash Palace, Varanasi. Designed with elegance and equipped with modern amenities, our rooms provide the perfect blend of luxury and convenience. ",
      image: "https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg",
      badge: "Popular Choice",
      features: ["Premium Bedding", "Air Conditioning", "Free Wi-Fi", "24-hour Room Service", "Flat-screen TV"]
    },
    {
      title: "Super Deluxe",
      subtitle: "Experience luxury and comfort",
      description: "Experience luxury and comfort in the Super Deluxe Rooms at Hotel Prakash Palace, Varanasi. Designed with elegance and equipped with modern amenities, these rooms offer a perfect retreat for travelers.",
      image: "https://plus.unsplash.com/premium_photo-1706140675031-1e0548986ad1?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bGl2aW5ncm9vbXxlbnwwfHwwfHx8MA%3D%3D",
      badge: "Most Booked",
      features: ["Spacious Interiors", "Premium Bedding", "Free Wi-Fi", "Flat-screen TV", "Modern Amenities"]
    },
    {
      title: "Premium",
      subtitle: "Experience unmatched comfort and elegance",
      description: "Experience unmatched comfort and elegance in the Premium Rooms at Hotel Prakash Palace, Varanasi. Thoughtfully designed to cater to discerning travelers, our premium rooms offer a blend of luxury and convenience. ",
      image: "https://img.freepik.com/premium-photo/cozy-fireplace-set-against-brick-wall-modern-living-room-concept-living-room-decor-fireplace-design-cozy-atmosphere-modern-interior-brick-wall-accents_864588-46489.jpg?semt=ais_hybrid&w=740&q=80",
      badge: "Luxury",
      features: ["Plush Bedding", "Air Conditioning", "Free Wi-Fi", "Flat-screen TV", "Modern Decor"]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-amber-400 to-orange-400 rounded-full mb-4">
            <span className="text-white font-semibold text-sm">Exquisite Accommodation</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-3">
            Best Hotel <span className="text-orange-600">Near Assi Ghat</span>
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Experience the perfect blend of traditional hospitality and modern luxury at Hotel Prakash Palace
          </p>
          <div className="flex justify-center mt-6">
            <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></div>
          </div>
        </div>

        {/* Rooms Grid - IMAGE ON TOP, CONTENT BELOW */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {rooms.map((room, index) => (
            <div key={index} className="group">
              {/* Room Image - NOW ON TOP */}
              <div className="relative overflow-hidden rounded-t-2xl shadow-xl">
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={room.image} 
                    alt={`${room.title} Room`}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    onError={(e) => {
                      e.target.src = `https://via.placeholder.com/600x400/FFD700/FFFFFF?text=${room.title}+Room`;
                    }}
                  />
                </div>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-4 left-4 text-white">
                    <span className="text-sm font-medium">View Gallery →</span>
                  </div>
                </div>
                {/* Room Type Label on Image */}
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-gray-900 font-semibold text-sm">{room.title}</span>
                </div>
                {/* Badge on Image */}
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold rounded-full shadow-lg">
                    {room.badge}
                  </span>
                </div>
              </div>

              {/* Room Content Card - NOW BELOW IMAGE */}
              <div className="bg-white rounded-b-2xl shadow-xl p-8 transform transition-all duration-500 hover:shadow-2xl border-t-0 border-b-4 border-amber-500">
                {/* Title and Subtitle */}
                <div className="mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{room.title}</h3>
                  <p className="text-orange-600 font-medium">{room.subtitle}</p>
                </div>

                {/* Description */}
                <p className="text-gray-700 mb-6 leading-relaxed text-justify">
                  {room.description}
                </p>

                {/* Features */}
                <div className="mb-8">
                  <h4 className="text-gray-900 font-semibold mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    Room Features:
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    {room.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-amber-500 rounded-full flex-shrink-0"></div>
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Book Now Button */}
                <button className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white py-3 rounded-lg font-semibold text-lg hover:shadow-lg transform hover:scale-[1.02] transition-all duration-300 group-hover:from-amber-600 group-hover:to-orange-600 flex items-center justify-center gap-2">
                  Book Now
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </button>

                {/* Quick Info */}
                <div className="mt-4 text-center">
                  <p className="text-xs text-gray-500">
                    <span className="inline-flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      Check-in: 2 PM | Check-out: 12 PM
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default RoomShowcaseSection;